"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HexColorInputWidget_1 = require("./HexColorInputWidget");
var Declarative_1 = require("../utils/Declarative");
var react_1 = require("react");
var Localize_1 = require("../../gen-src/Localize");
var CustomColorInput = /** @class */ (function (_super) {
    tslib_1.__extends(CustomColorInput, _super);
    function CustomColorInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomColorInput.prototype.render = function () {
        var divProps = { display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            width: this.props.width,
            fontSize: 'small'
        };
        var hexColorInputProps = {
            onColorSelected: this.props.onColorSelected,
            testId: this.props.testId,
            selectedColor: this.props.color,
            containerWidth: this.props.width
        };
        return (react_1.createElement('div', { style: divProps,
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'CustomColorInput') }, Localize_1.Messages.customColor(), react_1.createElement(HexColorInputWidget_1.HexColorInput, hexColorInputProps)));
    };
    return CustomColorInput;
}(React.Component));
exports.CustomColorInput = CustomColorInput;
//# sourceMappingURL=CustomColorInputWidget.js.map